import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { questions } from '../data/faq';
export function FAQ() {
  const [open, setOpen] = useState(0);
  return <section className="bg-navy-950 py-20" aria-labelledby="faq-title" data-id="element-48" data-mp="1ceqcvl9bmtg8">
      <div className="mx-auto max-w-3xl px-4" data-id="element-49" data-mp="1ccdp2rgvtov9">
        <SectionHeading id="faq-title" data-id="element-50" data-mp="2a2idkp7l8csk">Frequently Asked <span className="text-gold" data-id="element-51" data-mp="2a05w0d5qs4g1">Questions</span></SectionHeading>
        <div className="mt-10 space-y-3" data-id="element-52" data-mp="254gsxzuik5ez">
          {questions.map(([question, answer], index) => {
          const isOpen = index === open;
          return <article key={question} className={`overflow-hidden rounded-xl border bg-navy-900 transition-colors duration-150 ease-out ${isOpen ? 'border-steel' : 'border-steel/40'}`} data-id="element-53" data-mp="1v4zotmuwtzl4" data-mpi={index}>
                <h3 className="font-sans" data-id="element-54" data-mp="omjbg7oqnw9y">
                  <button type="button" className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left font-bold text-white transition-colors duration-150 ease-out hover:bg-navy-800 focus:outline-none focus-visible:ring-4 focus-visible:ring-inset focus-visible:ring-gold/50 sm:px-6" onClick={() => setOpen(isOpen ? -1 : index)} aria-expanded={isOpen} data-id="element-55" data-mp="jpjdyl5yg1ug">
                    <span data-id="element-56" data-mp="1fonbps1fh1rt">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-57" data-mp="1fnc93vjpy02a" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-58" data-mp="16pihgxwwfulg">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-59" data-mp="rzudfoxc2hu1">
                      <p className="border-t border-steel/15 px-5 py-4 leading-relaxed text-steel-light sm:px-6" data-id="element-60" data-mp="2pmdeu8zj3oug">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </article>;
        })}
        </div>
      </div>
    </section>;
}